import React from "react";

import BlockEditorContent from "./react";
import sanitise from "./sanitise-html";
import { Theme } from "./theme";
import { RichTextDocument } from "./types";
import { validateRichTextDocumentOrThrow } from "./validate";

export function validatedHtmlOrLexical(data: string) {
  if (data[0] === "{") return validateRichTextDocumentOrThrow(data);
  return sanitise(data);
}

/** Renders the HTML, if it is HTML and it passes validation, otherwise renders the string as Lexical (again if it passes validation) */
export function HtmlOrLexicalContent({ content, theme }: { content: string | null | undefined; theme: Theme }) {
  if (!content) return null;
  const validated = validatedHtmlOrLexical(content);
  if (typeof validated === "string") return <div dangerouslySetInnerHTML={{ __html: validated }} />;
  if (isLexicalEmpty(validated)) return null;
  return <BlockEditorContent content={validated} theme={theme} />;
}

export function isLexicalEmpty(document: RichTextDocument) {
  for (const node of document.root.children) {
    // Any node that doesn't have a list of children must represent content in its own right.
    if (!("children" in node)) return false;
    // Any node that has children, has content.
    if (node.children.length > 0) return false;
    // If the node has no content, loop to check if the next node has any.
  }
  // We didn't find any content in any of the nodes, so the whole document is empty
  return true;
}
